/**
 * Single entry point to the training API. Two adapters expose the same methods:
 *   - httpApi: the real routes of docs/training.md §4
 *   - demoApi: in-memory + localStorage, seeded from the referential (no backend needed)
 * Production always uses http. The demo adapter is a development tool only: it carries the
 * client's scenario fixtures, so its import sits behind `NODE_ENV !== "production"` and webpack
 * drops it (chunk included) from production builds. In dev it is loaded on first use.
 */
import { httpApi } from "./httpAdapter";

let defaultTrainingApi = httpApi;

if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_TRAINING_API === "demo") {
  defaultTrainingApi = new Proxy(
    { mode: "demo" },
    {
      get: (target, prop) => {
        if (prop in target) return target[prop];
        if (typeof prop === "symbol") return undefined;
        return (...args) => import("./demoAdapter").then((m) => m.demoApi[prop](...args));
      },
    }
  );
}

export { defaultTrainingApi, httpApi };
